import { createExcelAndDownload } from "../../../utils/reportExcelExport";

export function MemberReport(attendance) {
  const customHeadings = [
    { key: "status", label: "Status" },
    { key: "created_at", label: "Time", type: "time" },
    { key: "created_at", label: "Created On", type: "date" },
  ];
  createExcelAndDownload("Member Attendance Report", attendance, customHeadings);
}
